import { styled } from '@linaria/react';

import { LIGHT_COLORS } from '@/constants';

function RGBSnippet({ r, g, b }) {
  return (
    <Wrapper>
      rgb(<Color>{r}</Color>&nbsp;<Color>{g}</Color>&nbsp;
      <Color>{b}</Color>);
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: ${LIGHT_COLORS['--syntax-bg']};
  color: ${LIGHT_COLORS['--syntax-txt']};
  padding: 16px 32px;
  font-family: var(--font-family-mono);
`;

const Color = styled.span`
  color: ${LIGHT_COLORS['--syntax-str']};
  font-weight: var(--font-weight-bold);
`;

export default RGBSnippet;
